// extracted by mini-css-extract-plugin
export var caption = "newsletter-social-module--caption--08c41";
export var caption__lifestyle = "newsletter-social-module--caption__lifestyle--c211f";
export var description = "newsletter-social-module--description--4f516";
export var grid__lifestyle = "newsletter-social-module--grid__lifestyle--12b84";
export var icon = "newsletter-social-module--icon--68d59";
export var image = "newsletter-social-module--image--cf5fa";
export var imageLink = "newsletter-social-module--imageLink--ae1b2";
export var image__lifestyle = "newsletter-social-module--image__lifestyle--6e3c3";
export var post__lifestyle = "newsletter-social-module--post__lifestyle--043df";
export var spin = "newsletter-social-module--spin--e48bd";
export var titleInner = "newsletter-social-module--titleInner--99352";
export var titleText = "newsletter-social-module--titleText--df5fb";
export var title__lifestyle = "newsletter-social-module--title__lifestyle--bdf72";